export default "__VITE_ASSET__CIkBMCxp__"